/** @flow */
import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import type { AppState } from '../../redux/types/AppState';

type Props<T> = T & {
  component: React.Element<any>,
  signUpWith: string,
  isAuthenticated: boolean,
  computedMatch: any,
};

function PrivateRouteWithAccess<T>({ component, isAuthenticated, computedMatch, signUpWith, ...rest }: Props<T>) {
  const MyComponent: any = component;

  if (!isAuthenticated) {
    return (
      <Route {...rest} render={(props: Object) => (
        <Redirect to={{ pathname: `/access/with-${signUpWith}/${computedMatch.params.reference}`, state: { from: props.location } }} />
      )}
      />
    );
  }

  return (
    <div>
      <Route {...rest} render={(props: Object) => (
        <MyComponent {...props} />
      )}
      />
    </div>
  );
}

export default connect(
  (state: AppState) => ({
    isAuthenticated: state.session.isAuthenticated,
  }),
)(PrivateRouteWithAccess);



// WEBPACK FOOTER //
// ./src/advertisers/modules/authentication/PrivateRouteWithCampaignAccess.js